"use strict";

define('rs/models/session',['require','exports','module','underscore','jquery','config','vertebrae','rs/models/abstract','rs/helper','backbone.radio'],function (require, exports, module) {
  var _ = require('underscore');
  var $ = require('jquery');
  var Config = require('config');
  var Vertebrae = require('vertebrae');
  var AbstractModel = require('rs/models/abstract');
  var helper = require('rs/helper');
  var Radio = require('backbone.radio');
  var SessionModel = AbstractModel.extend({}, {
    rootURI: '/rs/',
    routes: {
      'PUT public/heartbeat': 'requestHeartbeat',
      'GET public/token': 'requestToken',
      'GET public/sessionInfo': 'requestSessionInfo'
    },
    parsers: {
      'public/token': function public_token(data) {
        window._csrf_parameter_name = data.parameterName;
        window._csrf_header_name = window._csrf_header_name || data.headerName;
        window._csrf_token = data.token;
        return data;
      }
    },
    activity: {},
    intervalTime: 60000,
    heartbeatTimestampEvents: ['documentLockChangeDate', 'messageReceiveDate', 'workflowLastBeginDate', 'lastNotificationDate'],
    heartbeatTimestampTracker: {},
    setHeartbeatSpeed: function setHeartbeatSpeed(ms) {
      this.intervalTime = ms;
      this.clearHeartbeat();
    },
    getActivity: function getActivity() {
      return this.activity || {};
    },
    getToken: function getToken() {
      return window._csrf_token;
    },
    removeOneLoginToken: function removeOneLoginToken() {
      return $.removeCookie(Config.ACCESS_COOKIE_NAME);
    },
    getOneLoginToken: function getOneLoginToken() {
      var parts = decodeURIComponent(document.cookie).split(';');
      var token = _.find(parts, function (x) {
        return x.includes(Config.ACCESS_COOKIE_NAME);
      });
      if (token) {
        return token.split('=')[1];
      }
      return '';
    },
    isOneLogin: function isOneLogin() {
      return document.cookie.includes(Config.ACCESS_COOKIE_NAME);
    },
    heartbeat: function heartbeat() {},
    clearHeartbeat: function clearHeartbeat() {
      var channel = Radio.channel('session');
      channel.trigger('clear:heartbeat');
      return this;
    },
    processHeartbeatResponse: function processHeartbeatResponse(response) {
      var eventName = null,
        eventData = null,
        newEventValue = null,
        oldEventValue = null;
      for (var i = 0, len = this.heartbeatTimestampEvents.length; i < len; i++) {
        fireEvent = false;
        eventName = this.heartbeatTimestampEvents[i];
        newEventValue = response[eventName];
        oldEventValue = this.heartbeatTimestampTracker[eventName];
        if (newEventValue != oldEventValue) {
          Vertebrae.Event.trigger(eventName, newEventValue);
          this.trigger(eventName, newEventValue);
        }
        this.heartbeatTimestampTracker[eventName] = newEventValue;
      }
    },
    fireHeartbeatResponse: function fireHeartbeatResponse(response) {
      if (response) {
        Vertebrae.Event.trigger("heartbeatRespondedWith" + response);
      }
    },
    doHeartbeat: function doHeartbeat(options) {
      var channel = Radio.channel('session');
      return channel.request('fetch:heartbeat', options || {});
    },
    triggerActivity: function triggerActivity(type, value) {
      var channel = Radio.channel('session');
      channel.trigger('activity', type, value);
      return this;
    },
    resetActivity: function resetActivity(type) {
      SessionModel.triggerActivity(type, null);
      return this;
    },
    triggerUIActivity: function triggerUIActivity() {
      SessionModel.triggerActivity('uiActivityDetected', true);
      return this;
    },
    resetUIActivity: function resetUIActivity() {
      SessionModel.triggerActivity('uiActivityDetected', false);
      SessionModel;
      return this;
    }
  });
  window.setHeartbeatSpeed = SessionModel.setHeartbeatSpeed.proxy(SessionModel);
  window.triggerUIActivity = SessionModel.triggerUIActivity.proxy(SessionModel);
  _.extend(SessionModel, Backbone.Events);
  module.exports = SessionModel;
});

